<template>
    <page>
		<module title="地址库管理">
			<module-column width="210" scroll>
				<div class="address">
					<c-tree ref="tree" :load="loadAreaTree" @node-click="areaSelect"></c-tree>
				</div>
			</module-column>
			
			<module-column enable-flex>
				<m-operate>
					<c-button color="gray" hollow power="b_basicinfo_address_library_add" @click="saveHandle">保存为草稿</c-button>
					<c-button color="gray" hollow power="b_basicinfo_address_library_loadGd" @click="loadGaode">加载高德数据</c-button>
					<c-button color="sys" power="b_basicinfo_address_library_release" @click="publishHandle">立即发布</c-button>
				</m-operate>
				
				<c-table ref="table" v-model="dataList" code="basicinfo_address_library_list">
					<c-table-column
						type="expand"
						label="名称"
						width="150"
						add-button="添加地区"
						expand-limit="2"
						@expand="loadChildren"
						@add="addHandle"
					>
						<template v-slot="row">
							<c-input v-if="row.expandData.level > 0" v-model="row.data.name" @change="editHandle(row)"></c-input>
							<span v-else>{{row.data.name}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="行政编码"
					>
						<template v-slot="row">
							<c-input v-if="row.expandData.level > 0" v-model="row.data.code" @change="editHandle(row)"></c-input>
							<span v-else>{{row.data.code}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="行政区号"
					>
						<template v-slot="row">
							<c-input v-if="row.expandData.level > 0" v-model="row.data.areaCode" @change="editHandle(row)"></c-input>
							<span v-else>{{row.data.areaCode}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="邮政编码"
					>
						<template v-slot="row">
							<c-input v-if="row.expandData.level > 0" v-model="row.data.zipCode" @change="editHandle(row)"></c-input>
							<span v-else>{{row.data.zipCode}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="别名(英文逗号分隔)"
						width="150"
					>
						<template v-slot="row">
							<c-input v-if="row.expandData.level > 0" v-model="row.data.aliasName" @change="editHandle(row)"></c-input>
							<span v-else>{{row.data.aliasName}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						type="sort"
						label="排序"
						@sort="sortHandle"
					></c-table-column>
			
					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="110"
					>
						<template v-slot="row">
							<c-table-button v-if="row.expandData.level == 1" power="b_basicinfo_address_library_del" @click="deleteHandle(row)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</module-column>
		</module>
	</page>
</template>

<script>
	import cTree from '@/components/unit/tree.vue'
	
	export default {
		name: 'm_basicinfo_address_library',
		
		components: {
			cTree
		},
		
		data() {
			return {
				defaultProps: {
					label: 'name',
					isLeaf: 'leaf'
				},
				
				dataList: []
			}
		},
		
		methods: {
			updateAreaTree(id) {
				if (id) {
					this.$refs.tree.getNode(item => item.data.id == id)[0].load();
				} else {
					this.$refs.tree.update();
				}
			},
			
			loadAreaTree(node, resolve) {
				this.request({
					url: '/address_library/list',
					data: {
						parent_id: node ? node.data.id : 0
					},
					success: data => {
						if (node && node.expandData.level == 1) {
							data.list.forEach(item => {
								item.leaf = true;
							});
						}
						resolve(data.list);
					}
				});
			},
			
			areaSelect(node) {
				this.dataList = [node.data];
				this.$nextTick(() => {
					this.$refs.table.getRow(0).expand();
				});
			},
			
			loadChildren(row, resolve) {
				this.request({
					url: '/address_library/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data.list);
					}
				});
			},
			
			addHandle(row, resolve) {
				resolve({
					id: '',
					name: '',
					code: '',
					areaCode: '',
					zipCode: '',
					aliasName: '',
					editFlag: true,
					newFlag: true
				})
			},
			
			editHandle(row) {
				row.data.editFlag = true;
			},
			
			sortHandle(row, type, next) {
				if (this.hasNew()) {
					this.$message({
						text: '请先保存新增地区至草稿'
					});
					return;
				}
				
				this.request({
					url: '/address_library/sort',
					data: {
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			deleteHandle(row) {
				this.$confirm({
					text: '确定要删除此地区吗？',
					resolve: () => {
						if (row.data.newFlag) {
							row.remove();
							return;
						}
						this.request({
							url: '/address_library/delete',
							data: {
								id: row.data.id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '删除成功'
								});
								row.remove();
								this.updateAreaTree(this.$refs.table.getRow(0).data.id);
							}
						});
					}
				});
			},
			
			saveHandle() {
				var parent = this.$refs.table.getRow(0);
				var list = parent ? this.$refs.table.getRow(item => item.data.editFlag) : [];
				
				if (!list.length) {
					this.$message({
						text: '您还未编辑任何数据'
					});
					return;
				}
				
				this.request({
					url: '/address_library/edit',
					data: {
						list: Array.from(list, item => {
							return {
								parent_id: parent.data.id,
								id: item.data.id,
								name: item.data.name,
								code: item.data.code,
								area_code: item.data.areaCode,
								zip_code: item.data.zipCode,
								alias_name: item.data.aliasName,
								sort: item.data.sort
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.getRow(0).load();
						this.updateAreaTree(parent.data.id);
					}
				});
			},
			
			loadGaode() {
				this.$confirm({
					text: '确定要加载高德最新数据到草稿吗？',
					resolve: () => {
						this.request({
							url: '/address_library/loadGd',
							loading: true,
							success: data => {
								this.$message({
									text: '已加载高德数据至草稿'
								});
								let parent = this.$refs.table.getRow(0);
								parent && parent.load();
								this.updateAreaTree();
							}
						});
					}
				});
			},
			
			publishHandle() {
				if (this.hasNew()) {
					this.$message({
						text: '请先保存新增地区至草稿'
					});
					return;
				}
				
				this.$confirm({
					text: '确定要发布吗？',
					resolve: () => {
						this.request({
							url: '/address_library/release',
							loading: true,
							success: data => {
								this.$message({
									text: '发布成功'
								});
							}
						});
					}
				});
			},
			
			hasNew() {
				return this.$refs.table.getRow(item => {
					return item.data.newFlag;
				}).length;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.address {
		min-height: 100%;
		background: #F9FAFC;
	}
</style>